<template>
  <b-card>
    <b-row>
      <label class="custom-font"><b>Personal Task Summary</b></label>

      <div class="button-style">
        <b-button
          class="flex-shrink-0 mr-1"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="goTask"
        >
          <feather-icon icon="ClipboardIcon" />
        </b-button>
      </div>
    </b-row>

    <!-- chart -->

    <div v-if="this.donutChart.series && this.donutChart.series.length > 0">
    <vue-apex-charts
        type="donut"
        height="350"
        :options="donutChart.chartOptions"
        :series="donutChart.series"
        @dataPointSelection="onDataPointSelection"
        />
    </div>
    
    
  </b-card>
</template>
  
  <script>
    
import { BButton, BCard, BCardTitle, BCardSubTitle, BRow } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ex } from '@fullcalendar/core/internal-common';
import Ripple from "vue-ripple-directive";
import { heightFade } from "@core/directives/animations";
import {mapGetters} from "vuex";

export default {
  name: "TaskChartWidget",
  components: {
    VueApexCharts,
    BButton,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BRow,
  },

  directives: {
    Ripple,
    heightFade,
  },
  
  data() {
    return {
      selectedPersonalTaskStatus: '',
      notStarted: "",
      donutChart: {
        series: [],
        chartOptions: {
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: ["#FFA1A1", "#ffe700", "#00d4bd"],
          dataLabels: {
            enabled: true,
            formatter(val) {
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "Total Tasks",
                  },
                },
              },
            },
          },
          labels: ["Not Started", "Ongoing", "Completed"],
          value: ["not_started", "ongoing", true],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
    };
  },

  async created() {
    try {
      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },


  computed: {
    ...mapGetters({
      filters: "allTaskModule/getFilters",
    }),
  },
methods: {

  goTask() {

    if(this.selectedPersonalTaskStatus){
      this.$store.dispatch("allTaskModule/setFilter", {
        key: "filterTaskStatus",
        value: this.selectedPersonalTaskStatus,
      });
    }

    this.$router.push({
        name: "employee-global-task-tracker",
      });
  },

  onDataPointSelection(event, chartContext, { dataPointIndex }){
    this.selectedPersonalTaskStatus = this.donutChart?.chartOptions.value[dataPointIndex];
  },

  async getExpanseSummaryCount() {
      return  this.$api.get("api/dashboard/personal-task-summary");
    },

  async loadItems() {

    try {

      const expanseSummaryCount = await this.getExpanseSummaryCount();
     const { completed, notStarted, ongoing } = expanseSummaryCount?.data?.data;
      
      this.donutChart.series = [notStarted, ongoing, completed];

    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }


},

},
};
</script>
  
  <style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
  